import DataGrid, { Column, Editing, FilterRow, HeaderFilter, SearchPanel, Selection } from 'devextreme-react/data-grid'
import React, { useState } from 'react'
import { AssetService } from '../../../../services/department-viags/asset.service';
import _ from 'lodash';
import { CreateNotification } from '../../../../components/notifier';

export const AssetList = (props: any) => {
    const {isEditMode, onSelectAsset} = props;
    const [assetList, setAssetList] = useState<any>([]);
    const [isLoading, setIsLoading] = useState(false);

    const getListAsset = async (assetCode: string) => {
      setIsLoading(true);
      const res = await AssetService.getList(assetCode);
      if (!res) return;
      const listTSCC = _.cloneDeep(res);
      setAssetList(listTSCC);
      setIsLoading(false);
    };

    const addNewRow = async (item: any) => {
      const fields = {
        CodeAsset: item.data.codeAsset,
        NameAsset: item.data.nameAsset,
      };
      const result = await AssetService.addAsset(fields);
      if (result.statusCode === 200) {
        CreateNotification({
          title: "Thành công",
          body: `Thêm tài sản thành công thành công.`,
          icon: "/icons/success.png",
        });
      } else {
        CreateNotification({
          title: "Thêm thất bại",
          body: `Không thể thêm tài sản này. ${result.message}`,
          icon: "/icons/success.png",
        });
      }
    };

    const handleSearchTextChange = (e: any) => {
      getListAsset(e);
    };

    const handleSelectionChange = (e: any) => {
      onSelectAsset(e.selectedRowsData);
    };

    // useEffect(() => {
    //     getListAsset('BANPHIM');
    // },[])
  
    return  (
      <DataGrid
        id="employees"
        dataSource={assetList}
        showRowLines={true}
        showBorders={true}
        columnAutoWidth={true}
        keyExpr="codeAsset"
        onRowInserting={addNewRow}
        className="px-2"
        noDataText="Không đọc được danh sách tài sản"
        onSelectionChanged={handleSelectionChange}
        loadPanel={{enabled: isLoading}}
      >
        <HeaderFilter visible={true} />
        <FilterRow visible={true} applyFilter={true} />
        <SearchPanel
          visible={true}
          placeholder="Nhập mã tài sản cần tìm"
          width={500}
          onTextChange={handleSearchTextChange}
        />
        <Editing
          allowAdding={isEditMode}
          allowUpdating={false}
          allowDeleting={isEditMode}
          confirmDelete={true}
          // mode="cell"
        />
        {!isEditMode && <Selection allowSelectAll={true} mode="multiple" showCheckBoxesMode="always" />}
        <Column dataField="codeAsset" caption="Mã tài sản" dataType="string" width={150} />
        <Column dataField="nameAsset" caption="Tên tài sản" dataType="string" />
        <Column dataField="increasingDate" caption="Ngày tăng" dataType="date" format="dd/MM/yyyy" />
        <Column dataField="updatedDate" caption="Ngày chỉnh sửa gần nhất" dataType="date" format="dd/MM/yyyy" />
        <Column dataField="numOfUpdate" caption="Số lần chỉnh sửa trong năm" dataType="number" />
      </DataGrid>
    );
}